import axios from '@/libs/api.request'

export const getWorkforceinfolist = (page, limit, key, value) => {
  return axios.request({
    url: '/v1/workforceinfo/workforceinfo/',
    method: 'get',
    params: {
      key,
      value,
      page,
      limit
    }
  })
}

export const operationWorkforceinfo = (data, meth) => {
  return axios.request({
    url: '/v1/workforceinfo/workforceinfo/',
    method: meth,
    data
  })
}